/* Фирмена покана: допълнения само за фирмения модел.
   Календар на месеца със звезда на датата, бутони за контакт, „Може би“,
   шеговити отговори и ефект при отваряне на билета според повода. */
(function () {
  'use strict';
  var M = globalThis.CORPORATE_MODEL;
  var current = null, edition = 'bg';

  var TXT = {
    bg: {
      call: 'Обадете се',
      week: ['П', 'В', 'С', 'Ч', 'П', 'С', 'Н'],
      months: ['Януари', 'Февруари', 'Март', 'Април', 'Май', 'Юни', 'Юли', 'Август', 'Септември', 'Октомври', 'Ноември', 'Декември'],
      marked: 'Датата на събитието',
      normal: ['Ще присъствам', 'Няма да мога', 'Може би'],
      funny: ['Идвам! Само не ми говорете за работа', 'Няма да дойда, имам по-добри планове (спане)', 'Може би, ако диванът ме пусне']
    },
    en: {
      call: 'Call',
      week: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      marked: 'Event date',
      normal: ['I will attend', 'I can’t make it', 'Maybe'],
      funny: ['I’m in! Just don’t talk shop', 'Can’t make it, I have better plans (sleep)', 'Maybe, if the sofa lets me go']
    }
  };
  function t(k) { return TXT[edition === 'en' ? 'en' : 'bg'][k]; }
  function q(sel, root) { return (root || document).querySelector(sel); }

  function phoneLinks(raw) {
    var p = String(raw || '').replace(/[^\d+]/g, '');
    if (/^00\d+/.test(p)) p = '+' + p.slice(2);
    else if (/^0\d{8,9}$/.test(p)) p = '+359' + p.slice(1);
    if (!/^\+?\d{7,15}$/.test(p)) return null;
    var digits = p.replace(/\D/g, '');
    return { tel: 'tel:' + p, viber: 'viber://chat?number=' + encodeURIComponent('+' + digits), wa: 'https://wa.me/' + digits };
  }

  function renderContact(d) {
    var box = q('.contact');
    if (!box) return;
    var row = q('.fx-contact', box);
    var links = phoneLinks(d.contactPhone);
    if (!links) { if (row) row.remove(); return; }
    if (!row) {
      row = document.createElement('div');
      row.className = 'fx-contact';
      box.insertBefore(row, q('.signature', box) || null);
    }
    row.replaceChildren();
    [[links.tel, t('call'), false], [links.viber, 'Viber', false], [links.wa, 'WhatsApp', true]].forEach(function (x) {
      var a = document.createElement('a');
      a.className = 'fx-btn';
      a.href = x[0];
      a.textContent = x[1];
      if (x[2]) { a.target = '_blank'; a.rel = 'noopener'; }
      row.appendChild(a);
    });
  }

  function renderChoices(state) {
    var set = state.funnyAnswers ? t('funny') : t('normal');
    ['yes', 'no', 'maybe'].forEach(function (v, i) {
      var input = q('input[name=attend][value=' + v + ']');
      var label = input && input.closest('label');
      if (!label) return;
      var orig = q('.fx-orig', label);
      if (!orig) { orig = document.createElement('span'); orig.className = 'fx-orig'; orig.hidden = true; label.appendChild(orig); }
      Array.prototype.slice.call(label.childNodes).forEach(function (n) { if (n.nodeType === 3) orig.appendChild(n); });
      var span = q('.fx-choice', label);
      if (!span) { span = document.createElement('span'); span.className = 'fx-choice'; label.appendChild(span); }
      span.textContent = set[i];
    });
  }

  // Календар на месеца, датата е отбелязана със звезда
  function renderCalendar(state) {
    var btn = document.getElementById('calendar');
    var fact = btn && btn.closest('.fact');
    var box = q('.fx-cal');
    if (!/^\d{4}-\d{2}-\d{2}$/.test(String(state.date || '')) || !fact) { if (box) box.remove(); return; }
    var y = Number(state.date.slice(0, 4)), mo = Number(state.date.slice(5, 7)) - 1, day = Number(state.date.slice(8, 10));
    var first = new Date(Date.UTC(y, mo, 1)).getUTCDay();
    var offset = (first + 6) % 7;
    var total = new Date(Date.UTC(y, mo + 1, 0)).getUTCDate();
    if (!box) {
      box = document.createElement('div');
      box.className = 'fx-cal';
      fact.insertBefore(box, btn);
    }
    var html = '<p class="fx-cal-head">' + t('months')[mo] + ' ' + y + '</p><div class="fx-cal-grid" role="grid" aria-label="' + t('months')[mo] + ' ' + y + '">';
    t('week').forEach(function (w) { html += '<span class="fx-cal-wd" aria-hidden="true">' + w + '</span>'; });
    for (var i = 0; i < offset; i++) html += '<span class="fx-cal-empty" aria-hidden="true"></span>';
    for (var dd = 1; dd <= total; dd++) {
      html += dd === day
        ? '<span class="fx-cal-day is-event" aria-current="date" aria-label="' + dd + ' · ' + t('marked') + '"><svg aria-hidden="true" viewBox="0 0 24 24"><path d="M12 1.6l3.1 6.6 7.2.9-5.3 5 1.4 7.1L12 17.7l-6.4 3.5L7 14.1l-5.3-5 7.2-.9z"/></svg><b>' + dd + '</b></span>'
        : '<span class="fx-cal-day">' + dd + '</span>';
    }
    box.innerHTML = html + '</div>';
  }

  // Ефекти при отваряне: сняг, конфети, златни искри, звездички и сърца
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function effectFor(state) {
    var e = state.effect || 'auto';
    if (e === 'auto') e = state.occasion === 'christmas' ? 'snow' : state.occasion === 'newyear' ? 'confetti' : 'sparkle';
    return e;
  }
  function play(kind, accent) {
    if (reduce || kind === 'none' || !document.body) return;
    var c = document.createElement('canvas');
    c.className = 'fx-effect';
    c.setAttribute('aria-hidden', 'true');
    document.body.appendChild(c);
    var ctx = c.getContext('2d');
    if (!ctx) { c.remove(); return; }
    var W, H, dpr = Math.min(2, window.devicePixelRatio || 1);
    function size() { W = innerWidth; H = innerHeight; c.width = W * dpr; c.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); }
    size();
    var colors = kind === 'confetti' ? [accent, '#ffffff', '#e85d75', '#4fb3d9', '#f2c14e', '#7bd389'] : kind === 'hearts' ? [accent, '#ffffff', '#e85d75'] : kind === 'snow' ? ['#ffffff'] : [accent, '#fff3c4', '#ffffff'];
    var count = kind === 'snow' ? 110 : kind === 'confetti' ? 150 : 80;
    var dur = kind === 'snow' ? 7000 : 4500;
    var parts = [];
    for (var i = 0; i < count; i++) {
      parts.push({
        x: Math.random() * W,
        y: kind === 'sparkle' ? Math.random() * H : -20 - Math.random() * H * 0.6,
        r: kind === 'snow' ? 1.5 + Math.random() * 3 : 3 + Math.random() * 5,
        vy: kind === 'snow' ? 0.6 + Math.random() * 1.2 : kind === 'sparkle' ? -0.2 - Math.random() * 0.5 : 2 + Math.random() * 3,
        vx: (Math.random() - 0.5) * (kind === 'confetti' ? 2.4 : 0.8),
        rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.2,
        ph: Math.random() * 6.28,
        col: colors[Math.floor(Math.random() * colors.length)],
        heart: kind === 'hearts' && Math.random() < 0.5
      });
    }
    function star(x, y, r) { ctx.beginPath(); for (var k = 0; k < 10; k++) { var a = k * Math.PI / 5 - Math.PI / 2, rr = k % 2 ? r * 0.45 : r; ctx.lineTo(x + Math.cos(a) * rr, y + Math.sin(a) * rr); } ctx.closePath(); ctx.fill(); }
    function heart(x, y, r) { ctx.beginPath(); ctx.moveTo(x, y + r * 0.35); ctx.bezierCurveTo(x - r * 1.2, y - r * 0.5, x - r * 0.4, y - r * 1.3, x, y - r * 0.5); ctx.bezierCurveTo(x + r * 0.4, y - r * 1.3, x + r * 1.2, y - r * 0.5, x, y + r * 0.35); ctx.fill(); }
    var t0 = performance.now();
    window.addEventListener('resize', size);
    (function frame(now) {
      var k = (now - t0) / dur;
      if (k >= 1) { window.removeEventListener('resize', size); c.remove(); return; }
      ctx.clearRect(0, 0, W, H);
      ctx.globalAlpha = k > 0.75 ? (1 - k) / 0.25 : 1;
      parts.forEach(function (p) {
        p.y += p.vy; p.x += p.vx + Math.sin(now / 600 + p.ph) * (kind === 'snow' ? 0.5 : 0.2); p.rot += p.vr;
        ctx.fillStyle = p.col;
        if (kind === 'snow') { ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.28); ctx.fill(); }
        else if (kind === 'confetti') { ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.fillRect(-p.r / 2, -p.r, p.r, p.r * 2); ctx.restore(); }
        else if (kind === 'sparkle') { var tw = 0.5 + 0.5 * Math.sin(now / 180 + p.ph); ctx.globalAlpha = tw * (k > 0.75 ? (1 - k) / 0.25 : 1); star(p.x, p.y, p.r * 0.8); }
        else { if (p.heart) heart(p.x, p.y, p.r); else star(p.x, p.y, p.r); }
      });
      requestAnimationFrame(frame);
    })(t0);
  }
  function watchOpening() {
    var ticket = document.getElementById('ticket');
    if (!ticket || ticket.dataset.fxWatch) return;
    ticket.dataset.fxWatch = '1';
    var fired = false;
    new MutationObserver(function () {
      if (fired || !ticket.classList.contains('open')) return;
      fired = true;
      var s = current || (M && M.defaults()) || {};
      var accent = /^#[0-9a-f]{6}$/i.test(String(s.accent || '')) ? s.accent : '#c9a24a';
      play(effectFor(s), accent);
    }).observe(ticket, { attributes: true, attributeFilter: ['class'] });
  }

  // След края на събитието: благодарност вместо формата за отговор (само за гостите)
  function renderThanks(state) {
    if (document.documentElement.dataset.firmenaRole !== 'guest') return;
    var end = 0;
    try { end = new Date(M.eventTimes(state).end).getTime(); } catch (e) { return; }
    var rsvp = document.getElementById('rsvp');
    if (!rsvp || !end || Date.now() < end) return;
    var box = q('.fx-thanks', rsvp);
    if (!box) {
      box = document.createElement('div');
      box.className = 'fx-thanks';
      box.innerHTML = '<p class="fx-thanks-k">✦</p><h2></h2><p></p>';
      rsvp.insertBefore(box, rsvp.firstChild);
    }
    var fb = q('.formbox', rsvp);
    if (fb) fb.hidden = true;
    box.querySelector('h2').textContent = edition === 'en' ? 'Thank you for being with us!' : 'Благодарим, че бяхте с нас!';
    box.querySelector('p:last-child').textContent = edition === 'en' ? 'It was a wonderful evening. See you at the next one.' : 'Вечерта беше чудесна. До следващия повод заедно!';
  }
  // Редактор: напомняне при смяна на датата
  document.addEventListener('input', function (e) {
    var el = e.target;
    if (!el || !el.dataset || (el.dataset.corp !== 'date' && el.dataset.corp !== 'time')) return;
    var label = el.closest('label');
    if (!label || q('.fx-date-note', label.parentNode)) return;
    var p = document.createElement('p');
    p.className = 'fx-date-note';
    p.textContent = 'Ако вече сте изпратили поканата: гостите, които са добавили събитието в календара си, трябва да го добавят отново, за да видят новата дата или час.';
    label.parentNode.insertBefore(p, label.nextSibling);
  });

  function renderAll() {
    if (!current) return;
    document.documentElement.dataset.corporateAuto = current.autoSound === true ? '1' : '0';
    var d = (current.editions && current.editions[edition]) || {};
    renderChoices(current);
    renderContact(d);
    renderCalendar(current);
    renderThanks(current);
    watchOpening();
  }

  document.addEventListener('firmena:apply', function (e) {
    if (!e.detail || !e.detail.state) return;
    current = e.detail.state;
    edition = e.detail.edition === 'en' ? 'en' : 'bg';
    renderAll();
  });
  if (M) setTimeout(function () { if (!current) { try { current = M.defaults(); renderAll(); } catch (e) {} } watchOpening(); }, 50);
})();

/* Изображение за споделяне: ?og=gold|boarding|vip|festive|elegant[&lang=en] показва само билета в рамка 1200×630 */
(function () {
  var p = new URLSearchParams(location.search);
  var d = p.get('og');
  if (!d || ['gold', 'boarding', 'vip', 'festive', 'elegant'].indexOf(d) < 0) return;
  var html = document.documentElement;
  html.classList.add('fx-og');
  function pick() {
    var b = document.querySelector('[data-design="' + d + '"]');
    if (b) { b.click(); setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 200); return true; }
    return false;
  }
  function setup() {
    var ticket = document.getElementById('ticket');
    if (!ticket) return;
    var stage = document.createElement('div');
    stage.className = 'fx-og-stage';
    var head = document.createElement('p');
    head.className = 'fx-og-head';
    head.textContent = p.get('lang') === 'en' ? 'Company party invitation ✦' : 'Покана за фирмено парти ✦';
    stage.appendChild(head);
    stage.appendChild(ticket);
    document.body.appendChild(stage);
    var tries = 0;
    (function again() { if (!pick() && tries++ < 40) setTimeout(again, 100); })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(setup, 300); });
  else setTimeout(setup, 300);
})();
